export default {"src":"/_next/static/media/nxt.b093213d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};